import { useEffect } from "react";
import { useApp } from "stores/app/context";
import CompletedWithoutErrors from "./CompletedWithoutErrors";
import CompletedWithErrors from "./CompletedWithErrors";
import CompletedWithoutAlbum from "./CompletedWithoutAlbum";

export default function UploadReady(props)
{
  const { legacyUpload: upload } = useApp();
  const files = upload.getData("filesCount");

  useEffect(() =>
  {
    return () =>
    {
      upload.clear();
    }
  });

  if(files.acceptedCount === files.successCount)
    return <CompletedWithoutErrors {...props} />
  if(files.successCount > 0 && files.failedCount < files.acceptedCount)
    return <CompletedWithErrors {...props} />
  if(files.successCount === 0)
    return <CompletedWithoutAlbum {...props} />

  return null;
}